import { connectFela } from '../../dependencies';
import SelectCompany from './SelectCompany';
import * as styles from './SelectCompany.styles';

export default connectFela(styles)(SelectCompany);
